import reducers from './searchReducers';

export default reducers;



// WEBPACK FOOTER //
// ./src/state/reducers/search/index.js